import React from "react";

const Landing = () => {
  return (
    <div className="bg-gradient-to-r from-[#e9efff] via-[#f7f5f7] to-[#f7f5f7] min-h-screen ">
      <main className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-16 flex flex-col-reverse lg:flex-row items-center justify-between gap-12">
        {/* Left Section */}
        <section className="max-w-xl">
          <div className="inline-flex items-center space-x-2 text-[#2a56f9] bg-[#dbe2ff] rounded-full px-4 py-1 text-xs font-semibold mb-4 select-none">
            <i className="fas fa-magic text-[10px]"></i>
            <span>AI-Powered Education Platform</span>
          </div>

          <h1 className="font-extrabold text-4xl sm:text-5xl leading-tight text-[#0a121f] mb-6">
            Transform Education
            <br />
            <span className="text-[#2a56f9]">With AI Innovation</span>
          </h1>

          <p className="text-[#4a4a4a] text-lg leading-relaxed mb-3">
            PSTVue is revolutionizing the educational landscape with an
            AI-powered ecosystem that transcends traditional boundaries. Our
            intelligent platform seamlessly unites every stakeholder in the
            educational journey—empowering teachers to innovate, students to
            excel, administrators to lead effectively, and parents to engage
            meaningfully. Experience the future of connected learning where
            technology meets pedagogy to create limitless possibilities.
          </p>

          <p className="text-[#4a4a4a] text-lg leading-relaxed mb-8">
            Our PST product build using Agentic AI, Generative AI, Fine tune
            LLMs, Multi-agent AI, RAG based models to run efficiently and give
            better prompts for every student Special feature of our product
            include "Tap your AI Voice simulator" which not only give question
            and answers but it coach, train, mentorship, guide and make
            betterment everyday and do follow up from where you left in form on
            notifications dashboard.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="https://mnr-pst-vue.vercel.app"
              className="inline-flex items-center justify-center bg-[#2a56f9] text-white font-semibold rounded-md px-6 py-3 hover:bg-[#1f3fcc] transition"
            >
              Get Started
              <i className="fas fa-arrow-right ml-2"></i>
            </a>
            <a
              href="https://mnr-pst-vue.vercel.app"
              className="inline-flex items-center justify-center border border-[#2a56f9] text-[#2a56f9] font-semibold rounded-md px-6 py-3 hover:bg-[#e6edff] transition"
            >
              Watch Demo
            </a>
          </div>
        </section>

        {/* Right Section */}
        <section className="flex-shrink-0 max-w-[320px] sm:max-w-md lg:max-w-lg">
          <img
            src="https://storage.googleapis.com/a1aa/image/8cdbd95e-3e10-452c-8743-56c3634f293f.jpg"
            alt="3D rendered woman with glasses holding a blue book"
            className="w-full h-auto"
          />
        </section>
      </main>
    </div>
  );
};

export default Landing;